import {
  CLIENT_LOCATIONS_REQUEST,
  CLIENT_LOCATIONS_SUCCESS,
  CLIENT_LOCATIONS_FAILURE,
  CLIENT_LOCATION_REQUEST,
  CLIENT_LOCATION_SUCCESS,
  CLIENT_LOCATION_FAILURE,
  CLIENT_LOCATION_UPDATE_REQUEST,
  CLIENT_LOCATION_UPDATE_SUCCESS,
  CLIENT_LOCATION_UPDATE_FAILURE
} from './ClientLocationManagerActions';

const initialState = {
  data: [],
  clientLocation: {},
  error: null,
  isClientLocationLoading: false,
};

export default function clientLocationManagerReducer(
  state = initialState,
  { type, payload },
) {
  switch (type) {
    case CLIENT_LOCATIONS_REQUEST:
      return { ...state, isClientLocationLoading: true };
    case CLIENT_LOCATIONS_SUCCESS:
      return {
        ...state,
        data: payload.data,
        clientLocation: {},
        error: null,
        isClientLocationLoading: false,
      };
    case CLIENT_LOCATIONS_FAILURE:
      return { ...state, error: payload.error, isClientLocationLoading: false };

    case CLIENT_LOCATION_REQUEST:
      return { ...state, isClientLocationLoading: true };
    case CLIENT_LOCATION_SUCCESS:
      return { ...state, clientLocation: payload.data, errors: null, isClientLocationLoading: false };
    case CLIENT_LOCATION_FAILURE:
      return { ...state, error: payload.error, isClientLocationLoading: false };

    case CLIENT_LOCATION_UPDATE_REQUEST:
      return { ...state, isClientLocationLoading: true };
    case CLIENT_LOCATION_UPDATE_SUCCESS:
      return { ...state, clientLocation: payload.data, errors: null, isClientLocationLoading: false };
    case CLIENT_LOCATION_UPDATE_FAILURE:
      return { ...state, error: payload.error, isClientLocationLoading: false };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/client-location-manager/ClientLocationManagerReducer.js